import makeConstants from 'lib/makeConstants';
import {Descendant} from 'slate';

export const saveStatus = ['default', 'saving', 'saved', 'loadError', 'saveError'] as const;

export type SaveStatusType = typeof saveStatus[number];

export const saveStatusType = makeConstants(...saveStatus);

interface InitialData {
  hasUnsavedEdits: boolean;
  timeElapsed: number;
  editStartTime: Date | null;
  lastDraftTime: Date | null;
  saveStatus: SaveStatusType;
  questionId: string;
  draftId: string | null;
  guessId: string | null;
  assignmentId: string | null;
  shouldShowExplanation: boolean;
  editorValue: Descendant[];
}

export interface WSStore {
  initialData: InitialData;
  getHasUnsavedEdits: () => InitialData['hasUnsavedEdits'];
  getWordCount: () => number;
  getSaveStatus: () => InitialData['saveStatus'];
  getLastSaveTime: () => InitialData['lastDraftTime'];
  getValue: () => InitialData['editorValue'];
  getDraftId: () => InitialData['draftId'];
  getGuessId: () => InitialData['guessId'];
}

export type DraftResponse = any;
